import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'website';
const pagePrefix = 'admin';
const action = 'TravelButtonInteracted';

const actionProps = {
  action,
  category,
  pagePrefix,
};

const telemObject = createTelemetryObject({
  actions: {
    whereMyGuestsAreStayingDialogShown: (page: string) => ({
      ...actionProps,
      page,
      action: 'FeatureDialogPopup',
      extraInfo: {
        name: 'WhereMyGuestsAreStayingFeatureDialogShown',
      },
    }),
    whereMyGuestsAreStayingDialogDismissed: (page: string) => ({
      ...actionProps,
      page,
      extraInfo: {
        name: 'WhereMyGuestsAreStayingFeatureDialogDismissed',
      },
    }),
    showEventConfirmedBookingsClicked: (page: string) => ({
      ...actionProps,
      page,
      extraInfo: {
        name: 'ShowEventConfirmedBookings',
      },
    }),
    showEventStaysClicked: (page: string) => ({
      ...actionProps,
      page,
      extraInfo: {
        name: 'ShowEventStays',
      },
    }),
    remindGuestsToBookClicked: () => ({
      ...actionProps,
      extraInfo: {
        name: 'remindGuestsToBookClicked',
      },
    }),
    remindOtherGuestsToBookClicked: () => ({
      ...actionProps,
      extraInfo: {
        name: 'remindOtherGuestsToBookClicked',
      },
    }),
    viewPageClicked: (tourName: string, stepName: string) => ({
      action: 'ButtonInteracted',
      category: 'Tour',
      extraInfo: {
        name: 'viewPageClicked',
        tourName,
        stepName,
      },
    }),
    exploreMoreHotelsClicked: (tourName: string, stepName: string) => ({
      action: 'ButtonInteracted',
      category: 'Tour',
      extraInfo: {
        name: 'exploreMoreHotelsClicked',
        tourName,
        stepName,
      },
    }),
  },
});

const { TelemetryProvider: GuestHotelBookingsListTelemetryProvider, useTelemetry: useGuestHotelBookingsListTelemetry } = createTelemetry(telemObject);

export { GuestHotelBookingsListTelemetryProvider, useGuestHotelBookingsListTelemetry };
